import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "./../../../environments/environment";
import { DeudaList } from "../models/deuda";
import { Observable } from "rxjs";
import { Persona } from "../models/persona";
import { comprobante } from "../models/comprobante";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class DeudaService {
  constructor(private http: HttpClient) {}

  getDeudaList(
    p_nrocta: string,
    p_cantDias: number,
    p_codigo: string,
    p_idTributo:number=0,
    
  ): Observable<DeudaList[]> {
    if (p_codigo == "ININ") {
      return this.http.get<DeudaList[]>(
        `${environment.urlService}DeudaBien/TraerDeudaBienININ?p_nrocta=${p_nrocta}&p_cantDias=${p_cantDias}&p_IdJurisdiccion=${environment.codigoJur}`
      );
    } else if (p_codigo == "AUAU") {
      return this.http.get<DeudaList[]>(
        `${environment.urlService}DeudaBien/TraerDeudaBien?p_patente=${p_nrocta}&p_cantDias=${p_cantDias}&p_IdJurisdiccion=${environment.codigoJur}`
      );
    } else if (p_codigo == "CICI") {
      debugger;
      return this.http.get<DeudaList[]>(
        `${environment.urlService}DeudaBien/TraerDeudaBienCEI?p_nrocta=${p_nrocta}&p_cantDias=${p_cantDias}&p_IdJurisdiccion=${environment.codigoJur}`
      );
    }
    else if (p_codigo == "OBSA") {
      return this.http.get<DeudaList[]>(
        `${environment.urlService}DeudaBien/TraerDeudaBienOBSA?p_nrocta=${p_nrocta}&p_cantDias=${p_cantDias}&p_IdJurisdiccion=${environment.codigoJur}`
      );
    }
    else if (p_codigo == "FIFI") {
      return this.http.get<DeudaList[]>(
        `${environment.urlService}DeudaBien/TraerDeudaPlandePago?p_nroboleta=${p_nrocta}&p_cantDias=${p_cantDias}&p_Jurisdiccion=${environment.codigoJur}`
        
      );
    }
    else if (p_codigo == "TAV") {
      return this.http.get<DeudaList[]>(
        // https://www.sigemyt.com/reportesapi/api/INGRESOS/reporteCedulonAU?reporteId=31&parametros=5704426
       `${environment.urlService}DeudaBien/TraerDeudaTasaVarias?p_nrocta=${p_nrocta}&p_cantDias=${p_cantDias}&p_IdJurisdiccion=${environment.codigoJur}&p_TipoTributo=${p_idTributo}`        
     //   `${environment.urlService}/INGRESOS/reporteCedulonAU?reporteId=31&parametros=${p_idComprobante}`        

      );
    }
    
  }

  //cargar tributos
  getTributos(){
   return this.http.get<any>(`${environment.urlService}TiposTributo/TraerConceptoTipoTributo?p_IdJurisdiccion=${environment.codigoJur}`)

  }
  getPersona(p_nrocta: string, p_tipotibuto: string): Observable<Persona> {
    return this.http.get<Persona>(
      `${environment.urlService}/DatosTributoPersona/BuscarTributoPersona?ClaveBien=${p_nrocta}&TipoTributo=${p_tipotibuto}&IdJurisdiccion=${environment.codigoJur}`
    );
  }


  addComprobante(data: comprobante): Observable<Response> {
    return this.http
      .post(`${environment.urlService}/Comprobantes/InsertarComprobante`, data)
      .pipe(map((response: any) => response));
  }
}
